import { render, staticRenderFns } from "./PLAdminSubmissionGenerator.vue?vue&type=template&id=8ce67c5a&scoped=true"
import script from "./PLAdminSubmissionGenerator.vue?vue&type=script&lang=js"
export * from "./PLAdminSubmissionGenerator.vue?vue&type=script&lang=js"
import style0 from "./PLAdminSubmissionGenerator.vue?vue&type=style&index=0&id=8ce67c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce67c5a",
  null
  
)

export default component.exports